/* jshint esversion: 6 */

import request from '@/utils/request';

export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  };
  return request({
    url: '/login/login',
    method: 'post',
    data,
  });
}

export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get',
    // params: { token }
  });
}

export function logoutApi() {
  return request({
    url: '/login/logout',
    method: 'post',
    // params: { token }
  });
}

// 钉钉登录获取扫码回调地址接口
export function getFeishuUrl(params) {
  return request({
    url: '/get_fei_url',
    method: 'get',
    params,
  });
}
// 钉钉登录获取用户信息接口
export function feiLogin(data) {
  return request({
    url: '/fei_login',
    method: 'post',
    data,
  });
}
// 钉钉扫码登录
export function dingLogin(data) {
  return request({
    url: '/login/login',
    method: 'post',
    data,
  });
}
// 绑定钉钉用户
export function bindDingUser(data) {
  return request({
    url: '/bind_ding_user',
    method: 'post',
    data,
  });
}

export function locationApi(data) {
  return request({
    url: `/report_location`,
    method: 'post',
    data,
  });
}


export const feishuAuthLogin = (data) => request('/fei_auth_login', { method: 'post', data });


// 获取用户的角色信息


export const getUserRole = (data)=> request('/admin/get_user_info_from_yun', { method: 'post', data }); 